import { NyuDataProperties } from '../../../shared/types'
import { cn } from '../utils/cn'

export function AxisLabelAboveChart({
    dataProperties,
}: {
    dataProperties: NyuDataProperties
}) {
    const hasMultipleAxes = !!dataProperties.secondaryAxis
    return (
        <div
            className={cn(
                'flex gap-4 flex-wrap my-2 items-center',
                'justify-between'
            )}
        >
            <p className="grow text-left">{dataProperties.axisTitle}</p>
            {hasMultipleAxes && (
                <p className="grow text-right">
                    {dataProperties.secondaryAxis?.axisTitle}
                </p>
            )}
        </div>
    )
}
